import { MessageOutlined } from '@material-ui/icons'

export default MessageOutlined
